// Disable dynamic styles in video.js
window.VIDEOJS_NO_DYNAMIC_STYLE = true;

// tslint:disable:no-unused-variable

// polyfills
import "es6-shim";
import "fullscreen-api-polyfill";
import "whatwg-fetch";
import "reflect-metadata";

import "./api/globalVintomNamespace/GlobalVintomNamespace";
// tslint:enable:no-unused-variable

import "././assets/style/index.scss";

export { Player } from "./api/player/Player";
export {
  PlayerConfigurationAPI as PlayerConfigurationAPIInternal,
  PlayerConfigurationWithVideoCodeAPI,
  PlayerDimensionsAPI,
  PlayerExecutionAPI,
  PlayerInitializationAPI,
  PlayerPersonalizationAPI,
  RunningPlayerAPI,
} from "./api/player/PlayerAPI";

export { CTAFunction } from "./api/cta/ctaFunction/CTAFunction";
export { CTAHandle } from "./api/cta/ctaFunction/CTAHandle";
export { PlayerCTAAPI } from "./api/cta/PlayerCTAAPI";

export { VintomErrorCode } from "./api/model/error/VintomErrorCode";
export { VintomError } from "./api/model/error/VintomError";

export { PlayerState } from "./api/model/playerState/PlayerState";
export { PlayerActionState } from "./api/model/playerState/PlayerActionState";
